import { useMutation } from '@tanstack/react-query';
import { automationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDeleteAutomation = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id: number) =>
    automationsRepo.deleteAutomation(id),
  );
